import { Typography } from "antd";

const { Title } = Typography;

export const AuthLoading = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <img
        src="https://cdn.dribbble.com/users/115601/screenshots/5356365/loading.gif"
        alt="Loading..."
      />
      <Title level={2} style={{ marginTop: "2em" }}>
        #EmpowerYourData
      </Title>
    </div>
  );
};
